import { CAMPAIGN, campaignAnnounced, daysLeft, lastWeek } from "../lib/campaign";
import CopyCode from "./CopyCode";

export default function CampaignStrip() {
  if (!campaignAnnounced()) return null;
  const left = daysLeft();
  const urgent = lastWeek();
  return (
    <div data-testid="campaign-strip" className="relative overflow-hidden text-white bg-[#c8102e] campaign-strip">
      <div className="relative max-w-7xl mx-auto px-4 h-11 flex items-center justify-center gap-2.5 sm:gap-3 text-[13px] sm:text-[15px] font-bold tracking-wide whitespace-nowrap overflow-hidden">
        <span className="hidden sm:inline-flex items-center uppercase tracking-[0.2em] text-[11px] px-2.5 py-1 rounded-md bg-[#ffce3a] text-[#0B2545] font-extrabold">{CAMPAIGN.label}</span>
        <span className="inline-flex items-center gap-2">
          <span className="font-extrabold text-[#ffce3a] text-base sm:text-lg">{CAMPAIGN.percent} %</span>
          <span>på alla paket med körlektioner</span>
          <span className="hidden sm:inline text-white/80 font-semibold">{CAMPAIGN.shortText}</span>
          <span className="text-white/70">·</span>
          <span className="inline-flex items-center gap-1.5">kod <CopyCode compact /></span>
        </span>
        {urgent && (
          <span className="inline-flex items-center px-2 py-0.5 rounded bg-white text-[#c8102e] text-[11px] font-extrabold uppercase tracking-wider strip-pulse" data-testid="campaign-days-left">
            {left === 0 ? "Sista dagen!" : left === 1 ? "1 dag kvar" : `${left} dagar kvar`}
          </span>
        )}
      </div>
    </div>
  );
}
